// used to render destination page (matches with backend)
export const DESTINATION_SEGMENT_ID = 'DESTINATION';
export const HOLIDAY_TYPE_SEGMENT_ID = 'HOLIDAY_TYPE';

// form type values for hero planner schedules
export const FORM_TYPE_DEFAULT = 'DEFAULT';
export const FORM_TYPE_CUSTOM = 'CUSTOM';
